module.exports = __webpack_public_path__ + "static/media/zsqz-qrcode.88e97e76.png";